import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Layout from "../components/Layout/Layout";

export default function ProtectedLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const getActiveItem = () => {
    const pathMap = {
      "/": "dashboard",
      "/shops": "view-shops",
      "/shops/add": "add-shop",
      "/banners": "view-banners",
      "/banners/add": "add-banner",
    };
    return pathMap[location.pathname] || "dashboard";
  };

  const handleNavigate = (itemId, href) => {
    navigate(href);
  };

  return (
    <Layout activeItem={getActiveItem()} onNavigate={handleNavigate}>
      <Outlet />
    </Layout>
  );
}
